<template>
	<div class="owl-carousel">
      <div class="item" v-for="(items, i) in arr">
				<p class="status">{{i+1}} из {{arr.length}}</p>
				<ul class="grid s_1 m_2 l_4">
					<li v-for="item in items">
						<div class="block">
							<a v-if="item.text" :href="item.href" class="textItem">{{item.text}}</a>
							<div class="imgContainer">
								<a v-if="item.img" :href="item.href" class="imgContent  waves-effect waves-light" :style="`background-image: url(${item.img})`"></a>
							</div>
						</div>
					</li>
				</ul>
      </div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {
			itemCount: 8
		}
	},

	computed: {
		arr(){
			let arr = [];
			let v = [];
			for(let i = 0; i < this.items.length; i++){
				v.push(this.items[i]);
				if(((i+1) % this.itemCount) == 0){
					arr.push(v);
					v = [];
				}else if((i+1) == this.items.length){
					arr.push(v);
					v = [];
				}
			}
			// console.log('arr.length = ' + arr.length);
			return arr
		}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: (this.items.length / this.arr.length) <= this.itemCount ? true : false,
				nav: true,
				autoHeight: true,
				onChanged: function(e){
					let str = '';
					setTimeout(function() {
						$(e.target).closest('.global-slider-container').find('.owl-item').each(function() {
							if($(this).hasClass('active')){
								try{
									str = $(this).find('.status')[0].innerText;
									$(e.target).closest('.js-top').find('.sliderInnerText').text(str);
								}catch(e){
									// console.log(e);
								}
							}
						});
					}, 0);
				},
				onInitialized: function() {
					$('.owl-next, .owl-prev').addClass('waves-effect waves-light');
				}
			}
		});
	},
	beforeMount() {
		var sizeArr = () => {
			var w = $(window).width();
			if((w >= 320) && (w <= 639)){
				this.itemCount = 2;
			}
			else if((w >= 640) && (w <= 1179)){
				this.itemCount = 4;
			}
			else if(w >= 1180){
				this.itemCount = 8;
			}
		}
		sizeArr();
		$(window).on('resize',function() {
			sizeArr();
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	.slider-categorySlider {
		background-color: #f7f8fd;
		// height: 225px;

		.owl-carousel {
			.owl-item{
				.item {
					// overflow: hidden;
					@include l_up{
						height: 225px;
					}
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.block{
						height: 100px;
						width: 100%;
						background-color: white;
						box-shadow: 0px 1px 4px rgba(242, 242, 242, 4);
						align-items: center;
						display: flex;
						padding: 0 25px;
						justify-content: space-between;
						.textItem{
							font-weight: 500;
							font-size: rem(14);
							line-height: rem(24);
							color: #393d4c;
							text-decoration: none;
						}
						.imgContainer{
							min-width: 50px;
							width: 50px;
							height: 100%;
							display: flex;
							align-items: center;
							.imgContent{
								width: 50px;
								height: 50px;
								margin: auto;
								border: 1px solid #e8ebef;
								border-radius: 100%;
								background-repeat: no-repeat;
								background-position: center;
								@include single-transition();
							}
						}
						&:hover{
							.text{
								font-weight: 600;
							}
							.imgContent{
								width: 34px;
								height: 34px;
								background-color: #006eb6;
								border-color: #006eb6;
								background-image: url('../img/arrow_forward.png')!important;
								@include single-transition();
							}
						}
					}
					.status{
						display: none;
					}
				}
			}
		}
		.owl-nav{
			position: absolute;
			top: -85px;
			right: 0;
			display: flex;

			.owl-next, .owl-prev{
				width: 45px;
				height: 45px;
				font-size: 0;
				background-color: #fff;
				border: 1px solid rgb(244, 244, 245);
				background-image: url('../img/slArr.png');
				background-position: center;
				background-repeat: no-repeat;
				border-radius: 100%;
				margin-left: 15px;
				@include single-transition();
				box-shadow: 0px 1px 4px rgba(242, 242, 242, 4);

				&.owl-prev{
					transform: rotate(180deg);
				}
				&:hover{
					background-color: #006eb6;
					border-color: #006eb6;
					filter: brightness(100%);
					background-image: url('../img/slArr2.png');
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// sliderCategory.vue?16f276a2